import { useState } from "react";
import { useSelector } from "react-redux";
import TechnicianAdditionalInstructions from "./TechnicianAdditionalInstructions";
import AppointmentDetails from "./AppointmentDetails";
import ServiceDetails from "./ServiceDetails";
import ServiceTotal from "../common/ServiceTotal";
import TechnicianPOC from "./TechnicianPOC";
import CPNotification from "../../../pages/Login/CPNotification";
import { TextWrapper, Wrapper, TextWrapperSpan, StyledImage } from "../../../constants/common/StyledGlobalConstants";
import PopOutIcon from "../../../assets/icons/External_link.svg";
import "../../../constants/common/StyleOnlyForScreenReader.css";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";

const RequestOverview = () => {
  const { windowSize } = useSelector((state) => state.ACCOUNT);
  const { jobResponseData, jobDetails, notesToTechnician, selectedSlotDetails, isReschedule } = useSelector(
    (state) => state.TECHNICIANAPPOINTMENT
  );
  const [isFAQWarningDisplayed, setIsFAQWarningDisplayed] = useState(false);

  const isMobile = windowSize.width < DEVICE_BREAKPOINTS.TABLET;

  // Use backend-calculated fees from job response instead of frontend serviceTotalFees
  const displayedFees = isReschedule 
    ? jobDetails.customerChargeAmount 
    : (jobResponseData?.estimateCustomerFee ?? 0);

  return (
    <Wrapper marginBottom="1.1rem">
      {/* This is a screen reader only text */}
      <div className="sr-only" tabIndex="-1" role="alert">
        <h1>Request overview</h1>
        {isFAQWarningDisplayed && (
          <>
            <span>warning</span>
            <span>
              You will continue to be billed for this device unless you update your contract. For more information, read the Contracts and
              cancellations FAQ.
            </span>
          </>
        )}
        <span>warning</span>
        <span>
          You must give 24 hours' notice to reschedule or cancel to avoid being charged a late cancellation fee. For more information, read the Fee
          information article.
        </span>
      </div>
      {/* This is a screen reader only text */}
      <Wrapper>
        <TextWrapper
          alignContent="center"
          fontSize="2.5rem"
          fontFamily="neue-haas-grotesk-display"
          fontWeight="700"
          lineHeight="3rem"
          aria-hidden="true"
          tabIndex="-1"
        >
          Request overview
        </TextWrapper>
        <TextWrapper fontSize="0.875rem" fontWeight="400" marginTop="1.5rem !important">
          Review your request before submitting.
        </TextWrapper>
      </Wrapper>
      <AppointmentDetails
        appointmentDateAndTime={selectedSlotDetails}
        appoinmentLocationAndDuration={
          isReschedule
            ? { ...jobDetails, appointmentLength: jobDetails?.jobDuration ? jobDetails.jobDuration / 60 : 0, stateCode: jobDetails.state }
            : jobResponseData
        }
      />
      <ServiceDetails
        serviceDetails={isReschedule ? jobDetails.services : jobResponseData.services}
        toSetValueFAQ={(res) => setIsFAQWarningDisplayed(res)}
      />
      <TechnicianPOC technicianPOC={isReschedule ? jobDetails : jobResponseData} isReschedule={isReschedule} />
      {(jobDetails?.notesToTechnician || notesToTechnician) && (
        <TechnicianAdditionalInstructions TechnicianAdditionalInstructions={isReschedule ? jobDetails?.notesToTechnician : notesToTechnician} />
      )}
      <ServiceTotal fees={displayedFees} />
      <TextWrapper marginTop={isMobile ? "2rem !important" : "2.5rem !important"} fontSize="0.875rem" fontWeight="400">
        You will be invoiced for the fees after the appointment has been completed.
      </TextWrapper>
      <Wrapper marginTop="1rem" fontSize="0.875rem">
        <CPNotification isOpen={true} notificationType="warning" closeButton={false} height="auto">
          <TextWrapperSpan fontWeight="400">
            You must give 24 hours' notice to reschedule or cancel to avoid being charged a late cancellation fee. For more information, read the{" "}
          </TextWrapperSpan>
          <TextWrapperSpan
            aria-label="Fee Information"
            tabIndex="0"
            fontWeight="400"
            textDecorationLine="underline"
            onClick={() => window.open("https://reveal-help.verizonconnect.com/hc/articles/17745278972435")}
            style={{ cursor: "pointer" }}
            id="cfst-request-overview-fees-info"
          >
            Fee information
          </TextWrapperSpan>
          <a
            href="https://reveal-help.verizonconnect.com/hc/articles/17745278972435"
            target="_blank"
            rel="noreferrer"
            tabIndex="-1"
            aria-hidden="true"
          >
            <TextWrapperSpan tabIndex="-1" verticalAlign="sub" marginLeft="2px" aria-hidden="true">
              <StyledImage
                tabIndex="-1"
                aria-hidden="true"
                width="1rem"
                height="1rem"
                src={PopOutIcon}
                alt="link"
                id="cfst-request-overview-fees-info-icon"
              />
            </TextWrapperSpan>
          </a>
          <TextWrapperSpan tabIndex="-1" fontWeight="400">
            {" "}
            article.
          </TextWrapperSpan>
        </CPNotification>
      </Wrapper>
      <TextWrapper marginTop="1rem !important" fontSize="0.875rem" fontWeight="400">
        By clicking <TextWrapperSpan fontWeight="700">{isReschedule ? `RESCHEDULE` : `SCHEDULE`}</TextWrapperSpan>, you confirm that the information
        provided is accurate.
      </TextWrapper>
    </Wrapper>
  );
};

export default RequestOverview;
